import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import {
	LanguageDividerStyled,
	LanguageOptionStyled,
	LanguagePickerContainerStyled,
} from 'shared/ui/LanguagePicker/LanguagePicker.styles';

interface Props {
	mobile?: boolean;
	full?: boolean;
}

export const LanguagePicker: FC<Props> = ({ mobile, full }) => {
	const { i18n } = useTranslation();

	const changeLanguage = (locale: string): void => {
		void i18next.changeLanguage(locale);
	};

	return (
		<LanguagePickerContainerStyled
			mobile={mobile}
			onClick={() => changeLanguage(i18n.language === `ru-RU` ? `en-GB` : `ru-RU`)}
		>
			<LanguageOptionStyled active={i18n.language === `ru-RU`}>{full ? `Русский` : `Ру`}</LanguageOptionStyled>
			<LanguageDividerStyled />
			<LanguageOptionStyled active={i18n.language === `en-GB`}>{full ? `English` : `En`}</LanguageOptionStyled>
		</LanguagePickerContainerStyled>
	);
};
